import { isValidHexColor, normalizeColorForCompare, normalizeHexColor } from "./hex-color";
import { SHAPE_FILL_PRESET_COLORS, SHAPE_STROKE_PRESET_COLORS } from "./shape-preference";

/** テキストの既定文字色。styles.css の --color-text と同じ値。 */
export const TEXT_DEFAULT_COLOR = "#1a1a2e";

/** 文字色に使用する濃色プリセット。 */
export const TEXT_COLOR_PRESET_COLORS: readonly string[] = SHAPE_STROKE_PRESET_COLORS;

/** 背景色に使用する淡彩プリセット。 */
export const TEXT_FILL_PRESET_COLORS: readonly string[] = SHAPE_FILL_PRESET_COLORS;

/** op とオブジェクト上で背景なしを表す値。 */
export const TEXT_FILL_TRANSPARENT = "transparent";

/** 文字色を比較用へ揃え、未設定は実際の描画と同じ既定色へ寄せる。 */
export function normalizeTextColorForCompare(color: string | undefined): string {
  return normalizeColorForCompare(color ?? TEXT_DEFAULT_COLOR);
}

/** 背景色を比較用へ揃え、hex 以外はすべて背景なしへ寄せる。 */
export function normalizeTextFillForCompare(fill: string | undefined): string {
  return isValidHexColor(fill) ? normalizeHexColor(fill) : TEXT_FILL_TRANSPARENT;
}

/** 描画できる背景色だけを返す。背景なしまたは非 hex の値では塗らない。 */
export function resolveTextBackground(fill: string | undefined): string | undefined {
  return isValidHexColor(fill) ? normalizeHexColor(fill) : undefined;
}
